import { Modal, Platform, View } from 'react-native';
import { CloseButton } from './closeButton';
import { ZoomableImage } from './zoomableImage';
import { themedStyleSheet } from '../../themes/themedStyleSheet';

type ImageLightboxProps = {
  url?: string;
  isOpened: boolean;
  onClose: () => void;
  onButtonChange?: React.ReactNode;
};

export const ImageLightBox: React.FC<ImageLightboxProps> = (
  props: ImageLightboxProps
) => {
  const isMobile = Platform.OS !== 'web';
  const buttonCloseAlign =
    isMobile && props?.onButtonChange ? styles.buttonCloseMobile : {};
  return (
    <Modal
      transparent={true}
      visible={props.isOpened}
      onRequestClose={props.onClose}
    >
      <View style={styles.modalContainer}>
        <View style={styles.innerContainer}>
          <View style={[styles.buttonClose, buttonCloseAlign]}>
            <CloseButton onClose={props.onClose} />
          </View>
          <ZoomableImage uri={props.url} />
          {props?.onButtonChange && (
            <View style={styles.changeButtonContainer}>
              {props.onButtonChange}
            </View>
          )}
        </View>
      </View>
    </Modal>
  );
};

const styles = themedStyleSheet((role) => ({
  modalContainer: {
    flex: 1,
    backgroundColor: role.inverseDim,
    position: 'relative',
    ...Platform.select({
      web: {
        cursor: 'default',
      },
    }),
  },
  innerContainer: {
    alignItems: 'center',
  },
  changeButtonContainer: {
    position: 'absolute',
    bottom: 100,
    left: 0,
    right: 0,
    alignItems: 'center',
    zIndex: 10,
  },
  buttonClose: {
    alignSelf: 'center',
    zIndex: 9,
    position: 'absolute',
    ...Platform.select({
      web: {
        top: 20,
      },
      default: {
        justifyContent: 'center',
        bottom: 84,
      },
    }),
  },
  buttonCloseMobile: {
    justifyContent: 'center',
    bottom: 20,
    right: 50,
  },
}));
